import Env from '../../services/Env'
import Bowser from 'bowser'

const browser = Bowser.getParser(window.navigator.userAgent)

export default class InterceptorLegacy {
  post(data: any): any {
    const baseURL = Env.INCOMING_URL
    const api = new XMLHttpRequest()
    const userAgent = JSON.stringify(browser)

    const message = {
      ...data,
      text: `
        ${Env.CLIENT_NAME}

        ${userAgent}

        Versão: ${Env.VERSION}
        ${data.text}
      `,
    }

    api.open('POST', baseURL)
    api.send(JSON.stringify(message))
  }
}
